export const generators = {
  PRODUCT_NAMING: 'PRODUCT_NAMING',
  PRODUCT_CONCEPT_TESTING: 'PRODUCT_CONCEPT_TESTING',
  CONCEPT_TESTING: 'CONCEPT_TESTING',
  BRAND_AWARENESS: 'BRAND_AWARENESS',
  BRAND_DIAGNOSTIC: 'BRAND_DIAGNOSTIC',
  BRAND_PERCEPTIONS: 'BRAND_PERCEPTIONS',
  LOGO_TESTING: 'LOGO_TESTING',
  CONJOINT_TESTING: 'CONJOINT_TESTING',
  MAXDIFF_TESTING: 'MAXDIFF_TESTING',
  ADVERTISING_TESTING: 'ADVERTISING_TESTING',
  VAN_WESTENDORP_TEMPLATE: 'VAN_WESTENDORP_TEMPLATE',
  ONLINE_RETAILER_PERCEPTIONS_TESTING: 'ONLINE_RETAILER_PERCEPTIONS_TESTING',
  RETAIL_CATEGORY_CONVERSION_TESTING: 'RETAIL_CATEGORY_CONVERSION_TESTING',
  CPG_BRAND_AWARENESS_PERCEPTIONS: 'CPG_BRAND_AWARENESS_PERCEPTIONS',
  CPG_STORE_CHOICE_DRIVERS: 'CPG_STORE_CHOICE_DRIVERS',
  CPG_PATH_TO_PURCHASE: 'CPG_PATH_TO_PURCHASE',
  GENERIC: 'GENERIC',
};

export const AB_TEST_TYPES = {
  MONADIC: 'monadic',
  SEQUENTIAL: 'sequential',
};
